import React from "react";
import {
  ImageThirtyFive,
  ImageThirtyFour,
  ImageThirtyThree,
  ImageThirtyTwo,
} from "../assets/images";

const EarlyDetection = () => {
  return (
    <div style={styles.container}>
      {/* Heading */}
      <h2 style={styles.title}>
        Early Detection – An Added <br /> Preventive Module
      </h2>
      <p style={styles.subtitle}>
        Support for women in fear or with family history—
        <br />
        confidential, guided, and action-oriented.
      </p>

      {/* Steps Timeline */}
      <div className="steps-wrapper">
        <div className="steps">
          {/* Step 1 */}
          <div style={styles.step}>
            <div className="circle" style={styles.circle}>
              1
            </div>
            <div className="lineRight" style={styles.lineRight}></div>
            <div style={styles.card}>
              <img
                src={ImageThirtyTwo}
                alt="Confidential"
                style={styles.icon}
              />
              <h3 style={styles.stepTitle}>
                Confidential self-assessment & symptom check
              </h3>
              <p style={styles.stepText}>
                Private Q&A to understand your risk.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div style={styles.step}>
            <div className="lineLeft" style={styles.lineLeft}></div>
            <div className="circle" style={styles.circle}>
              2
            </div>
            <div className="lineRight" style={styles.lineRight}></div>
            <div style={styles.card}>
              <img
                src={ImageThirtyThree}
                alt="Guided tutorials"
                style={styles.icon}
              />
              <h3 style={styles.stepTitle}>
                Guided breast exam tutorials & awareness prompts
              </h3>
              <p style={styles.stepText}>
                Simple-respectful instructions, with reminders.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div style={styles.step}>
            <div className="lineLeft" style={styles.lineLeft}></div>
            <div
              className="circle"
              style={{
                ...styles.circle,
                background: "#ffe5ec",
                color: "#ff4f79",
              }}
            >
              3
            </div>
            <div className="lineRight" style={styles.lineRight}></div>
            <div style={styles.card}>
              <img src={ImageThirtyFour} alt="AI-driven" style={styles.icon} />
              <h3 style={{ ...styles.stepTitle, color: "#ff4f79" }}>
                AI-driven test recommendations
              </h3>
              <p style={styles.stepText}>
                Personalized advice for screening tests.
              </p>
            </div>
          </div>

          {/* Step 4 */}
          <div style={styles.step}>
            <div className="lineLeft" style={styles.lineLeft}></div>
            <div className="circle" style={styles.circle}>
              4
            </div>
            <div style={styles.card}>
              <img
                src={ImageThirtyFive}
                alt="Booking assistance"
                style={styles.icon}
              />
              <h3 style={styles.stepTitle}>Booking assistance</h3>
              <p style={styles.stepText}>
                Find nearby labs and schedule easily.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={styles.stats}>
        <p style={styles.statsText}>
          <span style={styles.statsHighlightBox}>
            <span style={styles.statsHighlight}>
              60% of women in India are diagnosed late.
            </span>
          </span>
          <br />
          Early detection can enable simpler treatment and better survival.
        </p>
      </div>

      {/* Buttons */}
      <div style={styles.actions}>
        <button style={styles.primary}>Start Confidential Self-Check</button>
        <button style={styles.secondary}>Book a Screening Test</button>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          .steps {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
            align-items: flex-start;
          }

          @media (max-width: 992px) {
            .steps {
              grid-template-columns: repeat(2, 1fr);
              gap: 20px;
            }
          }

          @media (max-width: 600px) {
            .steps {
              grid-template-columns: 1fr;
              gap: 25px;
            }

            .lineLeft,
            .lineRight {
              display: none !important;
            }
          }

          @media (max-width: 480px) {
            h2 {
              font-size: 22px !important;
            }
            p {
              font-size: 14px !important;
            }
            button {
              width: 100% !important;
            }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "100%",
    margin: "0 auto",
    padding: "40px 20px",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  title: {
    fontSize: "clamp(30px, 10vw, 30px)",
    fontWeight: "600",
    marginBottom: "10px",
    color: "#222",
  },
  subtitle: {
    fontSize: "clamp(14px, 2vw, 16px)",
    color: "#555",
    marginBottom: "40px",
    lineHeight: 1.5,
  },
  step: {
    textAlign: "center",
    position: "relative",
  },
  circle: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "#0a6158",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600",
    fontSize: "16px",
    margin: "0 auto 20px auto",
    position: "relative",
    zIndex: 2,
  },
  lineLeft: {
    position: "absolute",
    top: "20px",
    left: "-50%",
    width: "50%",
    height: "2px",
    background: "#ddd",
    zIndex: 1,
  },
  lineRight: {
    position: "absolute",
    top: "20px",
    right: "-50%",
    width: "50%",
    height: "2px",
    background: "#ddd",
    zIndex: 1,
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    textAlign: "center",
    marginTop: "10px",
    height: "280px",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  icon: {
    width: "120px",
    height: "120px",
    marginBottom: "15px",
  },
  stepTitle: {
    fontSize: "clamp(15px, 2vw, 16px)",
    fontWeight: "600",
    marginBottom: "8px",
    color: "#333",
  },
  stepText: {
    fontSize: "clamp(13px, 1.8vw, 14px)",
    color: "#666",
  },
  stats: {
    background: "#ffeef1",
    padding: "20px",
    borderRadius: "12px",
    margin: "20px auto",
    display: "inline-block",
    textAlign: "left",
  },
  statsText: {
    fontSize: "clamp(14px, 2vw, 15px)",
    color: "#444",
    padding: "15px",
  },
  statsHighlightBox: {
    background: "#ffeef1",
    display: "inline-block",
    padding: "6px 10px",
    borderRadius: "8px",
  },
  statsHighlight: {
    fontWeight: "700",
    fontSize: "clamp(16px, 2.2vw, 18px)",
    color: "#1e1e1e",
  },
  actions: {
    display: "flex",
    gap: "50px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  primary: {
    padding: "18px 26px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
    fontWeight: "500",
    background: "#004d2d",
    color: "#fff",
    transition: "0.3s ease",
  },
  secondary: {
    padding: "18px 26px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
    fontWeight: "500",
    background: "#f2f2f2",
    color: "#333",
    transition: "0.3s ease",
  },
};

export default EarlyDetection;
